import React, { useEffect, useState } from 'react';
import PropTypes from 'prop-types';
import { t, Trans } from '@lingui/macro';
import { Combobox, Flex, P, RadioGroup } from '@decisiv/ui-components';
import ApplicationEventsApi from '../../../api/application_events';
import ActionsApi from '../../../api/actions';
import filterOptions from '../../../utils/filterOptions';

export default function TriggerFilter({
  handleForm,
  currentTriggerValue,
  currentEventsValue,
  currentActionsValue,
}) {
  const [applicationEventsItems, setApplicationEventsItems] = useState([]);
  const [actions, setActions] = useState([]);
  const [eventsInputValue, setEventsInputValue] = useState('');
  const [actionsInputValue, setActionsInputValue] = useState('');
  const [eventsValue, setEventsValue] = useState(
    currentEventsValue?.map((event) => ({
      id: event,
      label: event,
      value: event,
    })) || [],
  );
  const [actionsValue, setActionsValue] = useState(
    currentActionsValue?.map((action) => ({
      id: action,
      label: action,
      value: action,
    })) || [],
  );

  const handleCurrentEventsValue = () => {
    const updateEvents =
      currentEventsValue?.map((event) => ({
        id: event,
        label: event,
        value: event,
      })) || [];
    setEventsValue(updateEvents);
  };

  const handleCurrentActionsValue = () => {
    const updateActions =
      currentActionsValue?.map((action) => ({
        id: action,
        label: action,
        value: action,
      })) || [];
    setActionsValue(updateActions);
  };

  useEffect(() => {
    async function getData() {
      setActions([
        {
          id: 'loading',
          label: t`Loading...`,
          value: 'loading',
          disabled: true,
        },
      ]);

      const responseActions = await ActionsApi.fetchActions();

      /* istanbul ignore else */
      if (responseActions.data) {
        const allActions = responseActions.data
          .map((category) => category.attributes.actions)
          .flat();

        const parsedActions = [...new Set(allActions)].map((action) => ({
          id: action,
          label: action,
          value: action,
        }));
        setActions(parsedActions);
      }

      setApplicationEventsItems([
        {
          id: 'loading',
          label: t`Loading...`,
          value: 'loading',
          disabled: true,
        },
      ]);

      const addsCustomEvents = true;
      const responseApplicationEvents =
        await ApplicationEventsApi.fetchApplicationEvents(addsCustomEvents);
      /* istanbul ignore else */
      if (responseApplicationEvents.data) {
        const parsedApplicationEvents = responseApplicationEvents.data.map(
          (sn) => ({
            id: sn.attributes.name,
            label: sn.attributes.name,
            value: sn.attributes.name,
          }),
        );
        setApplicationEventsItems(parsedApplicationEvents);
      }
    }

    getData();
  }, []);

  return (
    <>
      <P marginBottom={1}>
        <Trans>Trigger</Trans>
      </P>
      <RadioGroup
        name="radio_trigger"
        items={[
          { label: t`Both`, value: 'Both' },
          { label: t`HTTP Call`, value: 'http_api_request' },
        ]}
        vertical
        value={currentTriggerValue}
        onChange={(e) => {
          handleForm({ event: e, field: 'trigger' });
        }}
      />
      {(currentTriggerValue === 'http_api_request' ||
        currentTriggerValue === 'Both') && (
        <Flex marginTop={1} marginLeft={3.4}>
          <Combobox
            hideLabel
            multiple
            marginTop={5}
            label={t`HTTP Call`}
            options={filterOptions(actions, actionsInputValue)}
            onChangeInputValue={(e) =>
              setActionsInputValue(e ? e.target.value : '')
            }
            value={actionsValue}
            zIndex={777}
            onChangeValue={(selectedId, options) => {
              handleForm({
                selectedId,
                options,
                field: 'actions',
              });
              handleCurrentActionsValue();
            }}
          />
        </Flex>
      )}
      <Flex marginTop={1}>
        <RadioGroup
          marginTop={5}
          name="radio_trigger"
          items={[{ label: t`Application Events`, value: 'application_event' }]}
          vertical
          value={currentTriggerValue}
          onChange={(e) => {
            handleForm({ event: e, field: 'trigger' });
          }}
        />
      </Flex>
      {(currentTriggerValue === 'application_event' ||
        currentTriggerValue === 'Both') && (
        <Flex marginTop={1} marginLeft={3.4}>
          <Combobox
            hideLabel
            multiple
            marginTop={5}
            label={t`Application Events`}
            options={filterOptions(applicationEventsItems, eventsInputValue)}
            onChangeInputValue={(e) =>
              setEventsInputValue(e ? e.target.value : '')
            }
            value={eventsValue}
            zIndex={777}
            onChangeValue={(selectedId, options) => {
              handleForm({
                selectedId,
                options,
                field: 'events',
              });
              handleCurrentEventsValue();
            }}
          />
        </Flex>
      )}
    </>
  );
}

TriggerFilter.propTypes = {
  handleForm: PropTypes.func.isRequired,
  currentTriggerValue: PropTypes.string.isRequired,
  currentEventsValue: PropTypes.arrayOf(PropTypes.string).isRequired,
  currentActionsValue: PropTypes.arrayOf(PropTypes.string).isRequired,
};
